
















import moment from "moment";
import { Vue, Component, Prop } from "vue-property-decorator";

import { ClientInfo, EContentType } from "@/types";
import { COUNTRY_MOBILE_CODES } from "@/constant";
import { EUserTypes, ECountryCode } from "@/pagesCom/ClientInfo/index.dto";

import FormSection, { IFormSection } from "./components/FormSection.vue";
import { removePlusSign } from "@/utils/common-utils";

@Component({
  components: {
    FormSection,
  },
})
export default class CompanyInfo extends Vue {
  @Prop({ type: Object, default: () => ({}) }) info!: ClientInfo;

  countryCodes = COUNTRY_MOBILE_CODES;

  get phoneNumber(): string {
    const { country, phoneNumber } = this.info;
    if (!country || !phoneNumber) return "N/A";
    return `${this.countryCodes[country] || ""} ${phoneNumber}`;
  }

  get isCompany() {
    return this.info.userType === EUserTypes.COMPANY;
  }

  get leftSection(): IFormSection[] {
    return [
      {
        title: "Details",
        data: [
          {
            label: "TYPE",
            type: EContentType.TEXT,
            content: this.info.businessType || "N/A",
            visible: this.isCompany,
          },
          {
            label: "INDUSTRY",
            type: EContentType.TEXT,
            content: this.info.subIndustry || "N/A",
            visible: true,
          },
          {
            label: "PLACE OF ESTABLISHMENT",
            type: EContentType.TEXT,
            content: this.info.placeOfEstablishment || "N/A",
            visible: this.isCompany,
          },
          {
            label: "DATE OF ESTABLISHMENT",
            type: EContentType.TEXT,
            content: this.info.dateOfEstablishment
              ? moment
                  .unix(+this.info.dateOfEstablishment)
                  .format("DD MMM YYYY")
              : "N/A",
            visible: this.isCompany && this.info.country === ECountryCode.PH,
          },
          {
            label: "NO. OF EMPLOYEES",
            type: EContentType.TEXT,
            content: this.info.noEmployees || "N/A",
            visible: this.isCompany,
          },
          {
            label: `EST. TRANSACTION VALUE${
              this.info.country === ECountryCode.ID ? " (IDR)" : ""
            }`,
            type: EContentType.TEXT,
            content: this.info.transactionPerMonth || "N/A",
            visible: this.isCompany,
          },
          {
            label: "WEBSITE",
            type: EContentType.TEXT,
            content: this.info.businessProfile || "N/A",
            visible: true,
          },
          {
            label: "PHONE NO",
            type: EContentType.TEXT,
            content:
              `+${removePlusSign(this.info.phoneNumberCountryCode)}${
                this.info.phoneNumber
              }` || "N/A",
            visible: true,
          },
          {
            label: "PHYSICAL STORE",
            type: EContentType.TEXT,
            content: this.info.hasPhysicalStore ? "Yes" : "No" || "N/A",
            visible: true,
          },
        ],
      },
    ];
  }

  get rightSection(): IFormSection[] {
    return [
      {
        title: "",
        data: [
          {
            label: "ADDRESS",
            type: EContentType.TEXT,
            content: `
            <span class="flex flex-1 font-lato text-sm font-medium text-grey-500 flex-col" >
              <span class="mb-1">
                ${this.info.addressline1}
              </span>
              <span class="mb-1 ${this.info.addressline2 ? "" : "hidden"}">
                ${this.info.addressline2}
              </span>
              <span class="mb-1">
                ${this.info.province || "N/A"}
              </span>
              <span class="mb-1">
                ${this.info.city || "N/A"}, ${this.info.postalCode || "N/A"}
              </span>
              <span class="mb-1">
                ${this.info.country || "N/A"}
              </span>
            </span>`,
            visible: true,
          },
        ],
      },
    ];
  }
}
